// extracted by mini-css-extract-plugin
export default {"cardWrapper":"index_cardWrapper__gEg4q"};